// extracted by mini-css-extract-plugin
module.exports = {"userPraiseChart":"userPraise_userPraiseChart__yEgsa","title":"userPraise_title__2gYGh"};